import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import {isAgExemptionExist, jsonCloneWithDates, propertyInfoFields} from "../../../../helpers/utils/OrderDetailUtils";
import InputField from "../../../../components/common/form/InputField";
import { getObjectiveArray } from "../../../../helpers/utils/Utils";
import CommonChosenInput from "./CommonChosenInput";
import SubdivisionListModal from "../Common/Modals/SubdivisionListModal";
import { useLazyGetSubdivisionWithComputedNameByIdQuery } from "../../../data/subDivision/subDivisionApi";


interface PropertyInfoSectionProps {
    curAccount: any;
    setIsSavedResult: any;
    accounts: any;
    setAccounts: any;
    certificate: any;
    setCertificate: any;
    showAccount: any;
    similarAccountList: any;
    setSimilarAccountList: any;
    editable: any;
    order?: any;
    setRender?: any;
    addParentAccountsForSubdivision?: any;
    setUpdatedAccountIndexList: any;
    authorities?: any;
    countyData?: any,
    setSubdivisionId?:any
}

export function PropertyInfoSection({
    curAccount,
    setIsSavedResult,
    accounts,
    setAccounts,
    certificate,
    setCertificate,
    showAccount,
    similarAccountList,
    setSimilarAccountList,
    editable,
    order,
    setRender,
    addParentAccountsForSubdivision,
    setUpdatedAccountIndexList,
    authorities,
    countyData,
    setSubdivisionId
}: PropertyInfoSectionProps) {
    const [confirmationModal, setConfirmationModal] = useState(false);
    const [showSubdivision, setShowSubdivision] = useState(false);
    const [disable, setDisable] = useState(false);

    const [triggerGetSubdivisionNameById, { data: subdivisionResponse }] = useLazyGetSubdivisionWithComputedNameByIdQuery();


    useEffect(() => {
        const subdivisionId = certificate?.accounts?.[showAccount]?.subdivisionId;
        if (
            curAccount?.subdivisionId &&
            curAccount.subdivisionId === subdivisionId &&
            (!subdivisionResponse || subdivisionResponse.id !== subdivisionId)
        ) {
            triggerGetSubdivisionNameById(subdivisionId);
        }
    }, [curAccount?.subdivisionId, showAccount, certificate, subdivisionResponse]);

    function updateSubdivision(e: React.MouseEvent) {
        e.preventDefault();
        setDisable(false);
        setConfirmationModal(false);

        const updatedAccount = {
            ...certificate.accounts[showAccount],
            taxDataSource: "EDITOR",
            subdivisionId: "",
        };

        const updatedAccounts = [...certificate.accounts];
        updatedAccounts[showAccount] = updatedAccount;

        setCertificate((prev: any) => ({
            ...prev,
            accounts: updatedAccounts,
        }));

        setIsSavedResult(false);

        setUpdatedAccountIndexList((prev: any) => {
            if (prev.includes(showAccount)) return prev;
            return [...prev, showAccount];
        });

        setRender(new Date().getMilliseconds());
    }

    return (
        <>
            <div className=" ">
                <div className="border-r border-highlight-5 h-full property_info table_data">
                    <table
                        className={
                            `${isAgExemptionExist(curAccount, 0) || isAgExemptionExist(curAccount, 1)
                                ? "scroll1 property-table"
                                : "scroll1 property-table2"
                            } text-sm w-full [&_td]:border [&_td]:border-surface-5 p-[6px] text-left`
                        }

                    >
                        <thead className="bg-highlight-5 text-text-0 relative">
                            <tr>
                                <th className="assessment_header pl-2 text-text-0 whitespace-nowrap">Property Info</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {[
                                { label: "Geographic ID", key: "geographicId" },
                                { label: "Property ID", key: "propertyId" },
                                { label: "Situs", key: "situsAddress" },
                                { label: "Assessed Owner(s)", key: "ownerName" },
                                { label: "Mailing", key: "ownerAddress" },
                                { label: "Deed Reference", key: "deed" },
                                { label: "Subdivision Code", key: "subdivisionCode" },
                            ].map((item) => (
                                <tr key={item.key}>
                                    <td className="pl-3 first_td">{item.label}</td>
                                    <td>
                                        {propertyInfoFields(
                                            curAccount,
                                            setIsSavedResult,
                                            certificate,
                                            setCertificate,
                                            item.key,
                                            editable,
                                            setUpdatedAccountIndexList,
                                            showAccount,
                                            item.key === "propertyId" ? similarAccountList : undefined,
                                            item.key === "propertyId" ? setSimilarAccountList : undefined
                                        )}
                                    </td>
                                </tr>
                            ))}

                            {/* Subdivision input */}
                            <tr>
                                <td className="pl-3">
                                    Subdivision
                                    {hasPermission(["SUBD-V"]) && curAccount && (
                                        <span>
                                            <a
                                                href={
                                                    curAccount.subdivisionId
                                                        ? `/subdivisions/${curAccount.subdivisionId}`
                                                        : "/subdivisions"
                                                }
                                                target="_blank"
                                            >
                                                <i className="fa fa-link ml-2 text-highlight-4" aria-hidden="true" />
                                            </a>
                                        </span>
                                    )}
                                </td>
                                <td>
                                    <div className="flex">
                                        <div className="w-full grow-1 mr-1">
                                            <InputField
                                                name="Collector"
                                                title=""
                                                className="form-control selector"
                                                placeholder="..."
                                                disabled
                                                hideLabel
                                                value={
                                                    order?.properties?.find(
                                                        (cur: any) =>
                                                            cur.propertyResult !== null &&
                                                            cur.propertyResult.taxId !== null &&
                                                            cur.propertyResult.taxId === curAccount?.propertyId
                                                    )?.propertyResult?.subdivisionName || ""
                                                }
                                            />
                                        </div>

                                        <div className="relative"
                                            style={{ width: "100%", flexGrow: 1, marginRight: "2px", }}
                                        >
                                            <InputField
                                                name="Collector"
                                                title=""
                                                className={
                                                    order?.state === "" || order?.county === ""
                                                        ? "selector readonly_bg"
                                                        : " selector "
                                                }
                                                hideLabel
                                                placeholder="Select Subdivision..."
                                                disabled
                                                value={
                                                    curAccount &&
                                                        curAccount?.subdivisionId &&
                                                        !subdivisionResponse?.loading &&
                                                        subdivisionResponse
                                                        ? subdivisionResponse?.subdivisionKey?.name
                                                        : ""
                                                }

                                            />

                                            <span
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (editable) {
                                                        if (curAccount.subdivisionId) {
                                                            setConfirmationModal(true);
                                                        } else if (order.state && order.county) {

                                                            setShowSubdivision(true);
                                                        }
                                                    }
                                                }}
                                                className={
                                                    curAccount?.subdivisionId
                                                        ? subdivisionResponse?.loading
                                                            ? "fas fa-sync fa-spin ml-xl-n4 search_span  mr-4 pr-2 absolute right-3 top-6"
                                                            : "fa fa-times ml-xl-n4 search_span absolute right-3 top-6"
                                                        : "fa fa-search ml-xl-n4 collector-account-modal search_span absolute right-3 top-6"
                                                }
                                            />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            {curAccount?.subdivisionId  && 
                            <tr>
                                <td className="pl-3 first_td">Subdivision Research status</td>
                                <td>
                                    <InputField
                                        placeholder="..."
                                        hideLabel
                                        type="text"
                                        value={subdivisionResponse?.subdivisionResearchStatus || ""}
                                        disabled={true}
                                    />
                                </td>
                            </tr>
                            }
                            <tr>
                                <td className="pl-3">Acreage</td>
                                <td>
                                    <NumberFormat
                                        placeholder="..."
                                        className="form-control"
                                        decimalScale={4}
                                        decimalSeparator="."
                                        fixedDecimalScale
                                        value={curAccount?.acreage || ""}
                                        onChange={(e: any) => {
                                            const newValue = e.target.value.replaceAll(',', '');
                                            const updatedAccount = {
                                                ...curAccount,
                                                acreage: newValue,
                                                taxDataSource: 'EDITOR',
                                                asOfDate: new Date(),
                                            };
                                            const updatedAccounts = accounts.map((acc:any, i:any) =>
                                                i === showAccount ? updatedAccount : acc
                                            );
                                            setAccounts(updatedAccounts);
                                            setIsSavedResult(false);
                                            setUpdatedAccountIndexList((prev: any) =>
                                                prev.includes(showAccount) ? prev : [...prev, showAccount]
                                            );
                                            setCertificate({
                                                ...certificate,
                                                accounts: certificate.accounts.map((acc:any, i:any) =>
                                                    i === showAccount ? { ...acc, ...updatedAccount } : acc
                                                ),
                                            });
                                        }}
                                        thousandSeparator
                                        disabled={!editable}
                                    />

                                </td>
                            </tr>

                            <tr>
                                <td className="pl-3">State Codes</td>
                                <td>
                                    <CommonChosenInput
                                        placeholder={"Enter State Codes..."}
                                        state={getObjectiveArray(certificate.accounts[showAccount]?.stateCodes) || []}
                                        isReadOnly={!editable}
                                        callBackFn={(value: any) => {
                                            const currentStateCodes = certificate.accounts[showAccount]?.stateCodes || [];

                                            let newStateCodes;
                                            if (Array.isArray(value)) {
                                                newStateCodes = value.map((c) => c?.value?.trim());
                                            } else {
                                                newStateCodes = [...currentStateCodes, value?.value?.trim() ?? value];
                                            }

                                            // Deep clone certificate to update immutably
                                            const updatedCertificate = jsonCloneWithDates(certificate);

                                            updatedCertificate.accounts[showAccount] = {
                                                ...updatedCertificate.accounts[showAccount],
                                                stateCodes: newStateCodes,
                                                taxDataSource: 'EDITOR',
                                                asOfDate: new Date(),
                                            };

                                            setCertificate(updatedCertificate);
                                            setIsSavedResult(false);

                                            // Update updatedAccountIndexList immutably — avoid duplicates
                                            setUpdatedAccountIndexList((prev: any) =>
                                                prev.includes(showAccount) ? prev : [...prev, showAccount]
                                            );

                                        }}
                                    />

                                </td>
                            </tr>

                            {(isAgExemptionExist(curAccount, 0) || isAgExemptionExist(curAccount, 1)) &&
                                Array.from(Array(7)).map((_, idx) => (
                                    <tr key={`empty-row-${idx}`}>
                                        <td className="pl-3" />
                                        <td style={{ opacity: 0 }}>1</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {showSubdivision &&
                countyData?.data &&
                Array.isArray(countyData.data) &&
                countyData?.data?.length > 0 &&
                countyData?.data[0]?.state?.stateAbbreviation === order.state && (
                    <SubdivisionListModal
                        show={showSubdivision}
                        setShow={setShowSubdivision}
                        certificate={certificate}
                        showAccount={showAccount}
                        setDisable={setDisable}
                        countyName={order.county}
                        county={countyData?.data?.find((cur: any) => cur.countyName === order.county)?.id}
                        isHoaTable={false}
                        addParentAccountsForSubdivision={addParentAccountsForSubdivision}
                        setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                        setSubdivisionId={setSubdivisionId}
                    />
                )}

            {confirmationModal && (
                <ConfirmationModal
                    title="Confirm"
                    bodyMessage="Are you sure you would like to remove the subdivision?"
                    onSubmit={updateSubdivision}
                    show={confirmationModal}
                    setShow={setConfirmationModal}
                    isLoading={false}
                />
            )}
        </>
    );
}

